import { Popup } from 'Lib/popup/popup';
import { getW } from 'Lib/w/w';
import { eksmoBP } from 'Lib/bp/bp';
import { showAuth } from 'Lib/show-auth/show-auth';
import { isLocalhost } from 'Lib/is-localhost/is-localhost';

const gulpReplacer = '/eksmo/_verstka';
const nomcodePage = document.querySelector('.book-page')?.getAttribute('data-book-id');
const elParentBtnIcon = document.querySelector('.will-read__parent-btn-item-icon use');
const elParentBtnText = document.querySelector('.will-read__parent-btn-item-text');

function setEvent() {
    document.querySelectorAll('.will-read').forEach((itemParent) => {
        const elsItem = itemParent.querySelectorAll('.will-read__btn-item');
        const elParent = itemParent.closest('.book-page') || itemParent.closest('.book');
        const isBook = elParent?.classList.contains('book');
        const elWillReadPopup = elParent?.querySelector('.will-read_popup');
        const elWillReadBtn = elParent?.querySelector('.js-will-read-popup');
        const popup = new Popup('popup', elWillReadPopup);
        const elBtnBox = itemParent.querySelector('.will-read__btn-box');
        const isAuthorized = document.querySelector('html').classList.contains('is-authorized');
        const nomcodeBook = isBook ? itemParent.getAttribute('data-nomcode') : '';

        if (getW() < eksmoBP.mdMin) {
            elWillReadBtn?.addEventListener('click', () => {
                if (isAuthorized) {
                    popup.open();
                } else {
                    showAuth();
                }
            });
        }

        elsItem.forEach((item) => {
            item.addEventListener('click', () => {
                if (isAuthorized && !item.classList.contains('will-read__btn-item_all-collection')) {
                    const isClickActive = item.classList.contains('will-read__btn-item_active'); // Если клик и так по активному пункту подборки
                    const idValue = isClickActive ? null : item.getAttribute('data-id');

                    elBtnBox.classList.add('will-read__btn-box_load');

                    fetch(isLocalhost() ? `${gulpReplacer}/ajax/will-read.json` : '/ajax/user-collections/will-read/change/', {
                        method: 'POST',
                        credentials: 'include',
                        body: JSON.stringify({
                            'type': idValue,
                            'nomcode': nomcodeBook || nomcodePage,
                        }),
                    })
                        .then((data) => {
                            if (data.ok) {
                                return Promise.resolve(data.json());
                            }

                            return Promise.reject(new Error(`Ошибка ${data.status}`));
                        })
                        .then(() => {
                            const isDefault = item.classList.contains('will-read__btn-item_default'); // Если клик по активному пункту подборки по умолчанию
                            const elParentBtnBox = document.querySelector('.will-read__parent-btn-box');
                            const elItemIcon = item.querySelector('use');

                            elsItem.forEach((itemInner) => {
                                itemInner.classList.remove('will-read__btn-item_active');
                            });

                            if (isClickActive) {
                                elParentBtnBox?.classList.remove('will-read__parent-btn-box_active');
                                elParentBtnIcon?.setAttribute('xlink:href', '#will');

                                if (elParentBtnText) {
                                    elParentBtnText.textContent = 'Буду читать';
                                }

                                if (isDefault) {
                                    elItemIcon?.setAttribute('xlink:href', '#will');
                                }
                            } else {
                                elParentBtnBox?.classList.add('will-read__parent-btn-box_active');
                                item.classList.add('will-read__btn-item_active');

                                if (elParentBtnText) {
                                    elParentBtnText.textContent = item.querySelector('.will-read__btn-item-text').textContent;
                                }

                                if (isDefault) {
                                    elItemIcon?.setAttribute('xlink:href', '#will-yes');
                                    elParentBtnIcon?.setAttribute('xlink:href', '#will-yes');
                                } else {
                                    itemParent.querySelector('.will-read__btn-item_default use')
                                        ?.setAttribute('xlink:href', '#will');

                                    elParentBtnIcon?.setAttribute('xlink:href', item.querySelector('.will-read__btn-item-icon use')
                                        .getAttribute('xlink:href'));

                                    itemParent.querySelector('.will-read_popup .will-read__btn-item_default use')
                                        ?.setAttribute('xlink:href', '#will');
                                }
                            }

                            // Если подборки в ЛК, то при выборе любой другой категории или кнопки "Удалить"
                            // книга перемещается из данного раздела, значит её нужно скрыть
                            if (isBook) {
                                elParent.remove();
                            }
                            //

                            popup.close();
                            elBtnBox.classList.remove('will-read__btn-box_load');
                            itemParent.classList.remove('link-drop-down_active');
                        })
                        .catch((err) => $.fancybox.open(`<div><p class="text text_c-gray">${err}</p></div>`));
                } else {
                    showAuth();
                }
            });
        });
    });
}

if (nomcodePage) {
    fetch(isLocalhost() ? `${gulpReplacer}/ajax/will-read.json` : '/ajax/user-collections/will-read/book/', {
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify({ nomcode: nomcodePage }),
    })
        .then((data) => {
            if (data.ok) {
                return Promise.resolve(data.json());
            }

            return Promise.reject(new Error(`Ошибка ${data.status}`));
        })
        .then((dataList) => {
            let htmlItems = '';
            let withoutActive = true;
            let activeItem = {};

            Object.values(dataList.DATA).forEach((item) => {
                htmlItems += `
                    <div class="will-read__btn-item${item.default ? ' will-read__btn-item_default' : ''}${item.active ? ' will-read__btn-item_active' : ''}" data-id="${item.id}">
                        <svg class="will-read__btn-item-icon"><use xlink:href="#${item.icon}"></use></svg>
                        <div class="will-read__btn-item-text">${item.name}</div>
                    </div>
                `;

                if (withoutActive && item.active) {
                    withoutActive = false;
                    activeItem = item;
                }
            });

            document.querySelectorAll('.will-read__btn-item-box').forEach((item) => {
                item.innerHTML = htmlItems;
            });

            if (!withoutActive) {
                elParentBtnIcon?.setAttribute('xlink:href', `#${activeItem.icon}`);

                if (elParentBtnText) {
                    elParentBtnText.textContent = activeItem.name;
                }
            }

            setEvent();
        });
} else {
    setEvent();
}
